var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.622,
    height: 22.363
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1050"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    "data-name": "Group 19",
    transform: "translate(1.067 1.918)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    "data-name": "Ellipse 2",
    transform: "translate(.433 -.418)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.76 12.65 5.674 5.674",
    "data-name": "Path 5"
  })))));
};
export { SvgMagnifyingGlass as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS42MjIiIGhlaWdodD0iMjIuMzYzIiB2aWV3Qm94PSIwIDAgMjEuNjIyIDIyLjM2MyI+DQogIDxnIGlkPSJHcm91cF8xMDUwIiBkYXRhLW5hbWU9Ikdyb3VwIDEwNTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjUyLjQ5OSAtMi4wODIpIj4NCiAgICA8ZyBpZD0iR3JvdXBfMTkiIGRhdGEtbmFtZT0iR3JvdXAgMTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNTMuNTY2IDQpIj4NCiAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMiIgZGF0YS1uYW1lPSJFbGxpcHNlIDIiIGN4PSI2LjUiIGN5PSI2LjUiIHI9IjYuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC40MzMgLTAuNDE4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMyIvPg0KICAgICAgPHBhdGggaWQ9IlBhdGhfNSIgZGF0YS1uYW1lPSJQYXRoIDUiIGQ9Ik0xOC40NTEsMTguNDUxbDUuNjc0LDUuNjc0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNS42OTEgLTUuODAxKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIzIi8+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==";